import Reflux from 'reflux';

const SessionActions = Reflux.createActions({
  'login': {asyncResult: true},
  'logout': {asyncResult: true},
  'validate': {asyncResult: true},
});

export default SessionActions;



// WEBPACK FOOTER //
// ../graylog2-server/graylog2-web-interface/src/actions/sessions/SessionActions.jsx